import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aldroubi-luxury/artifacts/t04kcxdw_Adobe%20Express%20-%20file-modified.png';
const FACEBOOK_URL = 'https://share.google/epUDvbFg7W53pSQi8';
const INSTAGRAM_URL = 'https://www.instagram.com/aldroubi_brico';

const Footer = () => {
  return (
    <footer className="py-10 sm:py-16 bg-[#0A0A0A] border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">

        {/* --- Mobile Layout --- */}
        <div className="lg:hidden">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block">
              <img src={LOGO_URL} alt="Aldroubi Brico" className="h-16 w-auto mx-auto" />
            </Link>
            <p className="text-gray-400 text-sm mt-4">Votre artisan de confiance en Normandie.</p>
          </div>

          <div className="space-y-4 mb-8">
            <a href="tel:0618709889" className="flex items-center justify-center gap-3 bg-gold/10 border border-gold/30 rounded-lg py-4 px-6 text-white">
              <Phone className="w-5 h-5 text-gold" />
              <span className="font-medium">06 18 70 98 89</span>
            </a>
            <div className="flex gap-3">
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-[#1877F2]/10 border border-[#1877F2]/40 rounded-lg py-3 text-white text-sm">
                <Facebook className="w-4 h-4 text-[#1877F2]" /> Facebook
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-[#E1306C]/10 border border-[#E1306C]/40 rounded-lg py-3 text-white text-sm">
                <Instagram className="w-4 h-4 text-[#E1306C]" /> Instagram
              </a>
            </div>
          </div>
        </div>

        {/* --- Desktop Layout --- */}
        <div className="hidden lg:grid lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO_URL} alt="Aldroubi Brico" className="h-20 w-auto" />
            </Link>
            <p className="text-gray-400 text-sm mb-4">Votre artisan de confiance. Électricité, peinture et revêtements en Normandie.</p>
            <div className="flex gap-3 mt-4">
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="p-2 bg-[#1877F2]/10 rounded text-[#1877F2] hover:bg-[#1877F2]/20 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="p-2 bg-[#E1306C]/10 rounded text-[#E1306C] hover:bg-[#E1306C]/20 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-serif text-lg text-white mb-6">Services</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>Dépannage Électrique</li>
              <li>Installation Électrique</li>
              <li>Peinture</li>
              <li>Revêtements de sols</li>
            </ul>
          </div>

          {/* Liens */}
          <div>
            <h4 className="font-serif text-lg text-white mb-6">Liens Utiles</h4>
            <ul className="space-y-3">
              <li><Link to="/nos-tarifs" className="text-gray-400 text-sm hover:text-gold">Nos Tarifs</Link></li>
              <li><Link to="/rendez-vous" className="text-gray-400 text-sm hover:text-gold">Prendre RDV</Link></li>
              <li><Link to="/realisations" className="text-gray-400 text-sm hover:text-gold">Nos Réalisations</Link></li>
              <li><Link to="/contact" className="text-gray-400 text-sm hover:text-gold">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg text-white mb-6">Contact</h4>
            <ul className="space-y-4 text-gray-400 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-gold shrink-0" />
                <span>Argentan et alentours<br />Normandie</span>
              </li>
              <li><a href="tel:0618709889" className="flex items-center gap-3 hover:text-gold"><Phone className="w-5 h-5 text-gold" /> 06 18 70 98 89</a></li>
              <li><a href="mailto:aldroubi.brico@gmail.com" className="flex items-center gap-3 hover:text-gold"><Mail className="w-5 h-5 text-gold" /> aldroubi.brico@gmail.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center text-gray-500 text-xs">
          © {new Date().getFullYear()} Aldroubi Brico. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;